export default __webpack_public_path__ + "static/media/3.e47396e5.png";